import * as IconMDI from 'mdi-material-ui';
import Facebook from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import YouTube from '@mui/icons-material/YouTube';
import XIcon from '@mui/icons-material/X';
import { RouteConfig } from 'types/routes';

export const DOMAIN_BASE = 'https://elevatormag.com';
export const DOMAIN_BASE_SHORT = 'elevatormag.com';

export const ROUTES = {
  POST: {
    fileApiPath: '/[slug]',
    navLinkText: 'Post',
    external: false,
  },
  PAGE_NOT_FOUND: {
    to: '/404',
    navLinkText: '404 Not Found',
    external: false,
  },
  ERROR: {
    to: '/_error',
    navLinkText: 'Error Page',
    external: false,
  },
  HOME: {
    to: '/',
    navLinkText: 'Home',
    external: false,
  },
  SEARCH: {
    to: '/search',
    navLinkText: 'Search',
    external: false,
  },
  CATEGORY: {
    to: '/category/',
    fileApiPath: '/category/[slug]',
    navLinkText: 'Category',
    external: false,
  },
  TYPE: {
    to: '/type/',
    fileApiPath: '/type/[slug]',
    navLinkText: 'Type',
    external: false,
  },
  MUSIC: {
    to: '/category/music/',
    navLinkText: 'Music',
    external: false,
  },
  VIDEOS: {
    to: '/category/videos/',
    navLinkText: 'Videos',
    external: false,
  },
  FEATURES: {
    to: '/category/features/',
    navLinkText: 'Features',
    external: false,
  },
  INTERVIEWS: {
    to: '/category/interviews/',
    navLinkText: 'Interviews',
    external: false,
  },
  TAG: {
    to: '/tag/',
    fileApiPath: '/tag/[slug]',
    navLinkText: 'Tag',
    external: false,
  },
  AUTHORS: {
    to: `/users/`,
    navLinkText: 'Authors',
    external: false,
  },
  SHOP: {
    to: 'https://shop.elevatormag.com/',
    navLinkText: 'Shop',
    external: false,
    target: '_blank',
  },
  ADVERTISE: {
    to: '/advertise',
    navLinkText: 'Advertise',
    external: false,
    CONFIRMATION: {
      to: '/campaigns/confirmation',
      navLinkText: 'Confirmation',
      external: false,
    },
  },
  CAMPAIGN: {
    to: '/campaign',
    navLinkText: 'Start campaign',
    external: false,
  },
  HELP: {
    to: 'https://help.elevatormag.com/',
    navLinkText: 'Help',
    external: false,
    target: '_blank',
  },
  SCAMMERS: {
    to: '/how-to-report-scammers',
    navLinkText: 'How to report scammers',
    external: false,
  },
  USER: {
    to: `/users/`,
    navLinkText: 'User',
    external: false,
  },
  STAFF: {
    to: '/staff',
    navLinkText: 'Staff',
    external: false,
  },
  SUBMIT: {
    to: '/submit',
    navLinkText: 'Submit',
    external: false,
    CONFIRMATION: {
      to: '/submit/confirmation',
      navLinkText: 'Confirmation',
      external: false,
    },
  },
  FAQ: {
    to: '/faq',
    navLinkText: 'FAQ',
    external: false,
  },
  ACCOUNT: {
    to: '/account/settings',
    navLinkText: 'Account',
    external: false,
    ACCOUNT_SETTINGS: {
      to: '/account/settings',
      navLinkText: 'Account Settings',
      external: false,
    },
    SUBMISSIONS: {
      to: '/account/submissions',
      navLinkText: 'Your Submissions',
      external: false,
    },
  },
  VERIFY: {
    to: '/verify',
    navLinkText: 'Verify Account',
    external: false,
  },
  CONTACT: {
    to: '/contact',
    navLinkText: 'Contact',
    external: false,
  },
  PROFILE: {
    to: '/profile',
    navLinkText: 'Profile',
    external: false,
    EDIT_PROFILE: {
      to: '/profile/edit',
      navLinkText: 'Edit Profile',
      external: false,
    },
  },
  LEGAL: {
    TOS: {
      to: '/legal/terms-of-service',
      navLinkText: 'Terms',
      external: false,
    },
    PRIVACY: {
      to: '/legal/privacy-policy',
      navLinkText: 'Privacy Policy',
      external: false,
    },
  },
  ADMIN: {
    to: process.env.ADMIN_URL ?? '#',
    navLinkText: 'Admin Overview',
    external: false,
    target: '_blank',
  },
  AUTH: {
    to: process.env.AUTH_URL ? `${process.env.AUTH_URL}/login` : '#',
    navLinkText: 'Log In',
    external: false,
    LOG_IN: {
      to: process.env.AUTH_URL ? `${process.env.AUTH_URL}/login` : '#',
      navLinkText: 'Log In',
      external: false,
    },
    CREATE_ACCOUNT: {
      to: process.env.AUTH_URL ? `${process.env.AUTH_URL}/create-account` : '#',
      navLinkText: 'Create Account',
      external: false,
    },
  },
};

export const APPBAR_ROUTES: RouteConfig[] = [
  ROUTES.MUSIC,
  ROUTES.VIDEOS,
  ROUTES.FEATURES,
  ROUTES.INTERVIEWS,
  ROUTES.SHOP,
];

export const FOOTER_ROUTES: RouteConfig[] = [
  ROUTES.FEATURES,
  ROUTES.SHOP,
  ROUTES.SUBMIT,
  ROUTES.ADVERTISE,
  ROUTES.STAFF,
  ROUTES.CONTACT,
  ROUTES.HELP,
  ROUTES.LEGAL.TOS,
  ROUTES.LEGAL.PRIVACY,
];

export const SOCIAL_MEDIA = {
  FACEBOOK: {
    route: 'https://www.facebook.com/ElevatorMag/',
    type: 'facebook',
    icon: Facebook,
  },
  INSTAGRAM: {
    route: 'https://www.instagram.com/elevator_/',
    type: 'instagram',
    icon: Instagram,
  },
  X: {
    route: 'https://x.com/elevator_',
    type: 'x',
    icon: XIcon,
  },
  YOUTUBE: {
    route: 'https://www.youtube.com/user/LVTRmag',
    type: 'youtube',
    icon: YouTube,
  },
  SOUNDCLOUD: {
    route: 'https://soundcloud.com/lvtrmag',
    type: 'soundcloud',
    icon: IconMDI.Soundcloud,
  },
  SPOTIFY: {
    route:
      'https://open.spotify.com/playlist/31jkZXTNwXu0QNvAIG4psQ?si=kHiK9w4ZQRm8Xs59buaP1Q&nd=1',
    type: 'spotify',
    icon: IconMDI.Spotify,
  },
};
